import DGHead from "./dg-head.vue";
import DGCopyright from "./dg-copyright.vue";
import DGPaswIntensity from "./dg-pasw-intensity.vue";
import DGState from "./dg-state.vue";
import DGTitle from "./dg-title.vue";
import DGUpload2 from "./dg-upload2.vue";
import DGDialog from "./dg-dialog.vue";
import DGList from "./dg-list.vue";
import DGListItem from "./dg-list-item.vue";
import DGFormDialog from "./dg-form-dialog.vue";
import DGUpload from "./dg-upload.vue";
import DGPage from "./dg-page.vue";
import DGListState from "./dg-list-state.vue";
import DGStep from "./dg-step.vue";
import DGAlertBox from "./dg-alert-box.vue";
import DgCascader from "./dg-cascader.vue";
import DgForm from "./dg-form.vue";
import DgFormItem from "./dg-form-item.vue";
import DGUploadList from "./dg-upload-list.vue";
import DGLink from "./dg-link.vue";
import DgXiaojin from "./dg-xiaojin.vue";
import breadcrumb from "./breadcrumb.vue";
import DgVoid from "./dg-void.vue";
import DgVoidUpload from "./dg-void-upload.vue";
import DgCopy from "./dg-copy.vue";
import dgDragScope from "./dg-drag-scope.vue";
import DgSignaturePad from "./dg-signaturePad.vue";
import Dgdrag from "./dg-drag.vue";
import DgContact from "./dg-contact.vue";
import DgHelp from "./dg-help.vue";
import DGProgress from "./dg-progress.vue";
import DGRate from "./dg-rate.vue";
import DGAd from "./dg-gg.vue";
import DGLawsuitUpload from "./dg-lawsuit-upload.vue"
import DgLawsuitFileCheck from "./dg-lawsuit-file-check.vue";
import DGText from "./dg-text.vue";
import DGContactus from "./dg-contactus.vue";
import DGLogo from "./dg-logo.vue";


let components = [DGLogo,DgLawsuitFileCheck,DGContactus, DGLawsuitUpload, DGRate, DGProgress, DgHelp, DgCopy, DgContact, DgSignaturePad, Dgdrag, dgDragScope, DgVoidUpload, DgVoid, breadcrumb, DgXiaojin, DGLink, DGUploadList, DgFormItem, DgForm, DgCascader, DGCopyright, DGList, DGUpload2, DGFormDialog, DGListItem, DGTitle, DGUpload, DGDialog, DGHead, DGPaswIntensity, DGState, DGPage, DGListState, DGStep, DGAlertBox, DGAd, DGText];// export default {

let install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  DGLogo,
  DGLawsuitUpload,
  DGRate,
  DGProgress,
  DGContactus,
  DgCopy,
  DGCopyright,
  DGStep,
  DGUpload2,
  DGAlertBox,
  DGFormDialog,
  Dgdrag,
  DGList,
  DGListItem,
  DGDialog,
  DGUpload,
  DgContact,
  DGTitle,
  DGPaswIntensity,
  DgSignaturePad,
  dgDragScope,
  DGState,
  DGHead,
  DGPage,
  DGListState,
  DgCascader,
  DgForm,
  DgFormItem,
  DGUploadList,
  DGLink,
  DgXiaojin,
  breadcrumb,
  DgVoid,
  DgVoidUpload,
  DgHelp,
  DgLawsuitFileCheck,
  DGAd,
  DGText
};
